module.exports = __webpack_public_path__ + "img/24.00e83e16.jpg";